import React, { useState, useEffect, useRef, useCallback } from "react";
import "../styles/LivePrices.css";
import SmallBox, { sarrafiyeValues } from "../components/SmallBox";
import ceyrekImage from "../assets/ziynet/ceyrek.jpg";
import yarimImage from "../assets/ziynet/yarım.jpg";
import ziynet5Image from "../assets/ziynet/ziynet5.jpg";
import image0 from "../assets/images/image0.png";

import googleImg from '../assets/mobil/google.png';
import iosImg from '../assets/mobil/ios.png';
import BottomConvertCalculator from '../components/BottomConvertCalculator';
import { Link } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";

// USD İkonu SVG bileşeni
const USDIcon: React.FC = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '4px' }}>
    <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
  </svg>
);

interface Price {
  code: string;
  bid: number;
  ask: number;
  category: string;
  source: string;
}

interface GoldDetail {
  name: string;
  image: string;
  description: string;
  details: { [key: string]: string | number };
}

const goldData: { [key: string]: GoldDetail } = {
  "E.ÇEYREK": {
    name: "Çeyrek Altın",
    image: ceyrekImage,
    description: "Çeyrek Altın, ziynet takı grubunun en küçük üyesidir.",
    details: {
      Cins: "Ziynet Çeyrek",
      Ağırlık: "1,754 Gram",
      Ayar: "22 Ayar",
      Çap: "18 mm",
      "Torba Adet": "610 Adet",
      "Kulpsuz Gram": "1,754 Gram",
    },
  },
  "ÇEYREK": {
    name: "Çeyrek Altın",
    image: ceyrekImage,
    description: "Çeyrek Altın, ziynet takı grubunun en küçük üyesidir.",
    details: {
      Cins: "Ziynet Çeyrek",
      Ağırlık: "1,754 Gram",
      Ayar: "22 Ayar",
      Çap: "18 mm",
      "Torba Adet": "610 Adet",
      "Kulpsuz Gram": "1,754 Gram",
    },
  },
  "E.YARIM": {
    name: "Yarım Altın",
    image: yarimImage,
    description: "Yarım Altın, ziynet takı grubunun ikinci en küçük üyesidir.",
    details: {
      Cins: "Ziynet Yarım",
      Ağırlık: "3,508 Gram",
      Ayar: "22 Ayar",
      Çap: "22 mm",
      "Torba Adet": "305 Adet",
      "Kulpsuz Gram": "3,508 Gram",
    },
  },
  "YARIM": {
    name: "Yarım Altın",
    image: yarimImage,
    description: "Yarım Altın, ziynet takı grubunun ikinci en küçük üyesidir.",
    details: {
      Cins: "Ziynet Yarım",
      Ağırlık: "3,508 Gram",
      Ayar: "22 Ayar",
      Çap: "22 mm",
      "Torba Adet": "305 Adet",
      "Kulpsuz Gram": "3,508 Gram",
    },
  },
  "ZIYNET 5": {
    name: "Ziynet 5",
    image: ziynet5Image,
    description: "Ziynet Beşli, ziynet takı grubunun en büyük üyesidir.",
    details: {
      Cins: "Ziynet Beşli",
      Ağırlık: "35,08 Gram",
      Ayar: "22 Ayar",
      Çap: "45 mm",
      "Torba Adet": "31 Adet",
      "Kulpsuz Gram": "35,08 Gram",
    },
  },
  "E.ZIYNET 5": {
    name: "Ziynet 5",
    image: ziynet5Image,
    description: "Ziynet Beşli, ziynet takı grubunun en büyük üyesidir.",
    details: {
      Cins: "Ziynet Beşli",
      Ağırlık: "35,08 Gram",
      Ayar: "22 Ayar",
      Çap: "45 mm",
      "Torba Adet": "31 Adet",
      "Kulpsuz Gram": "35,08 Gram",
    },
  },
};

const ITEMS_PER_PAGE = 15;

const LivePrices: React.FC = () => {
  const { t } = useLanguage();
  const [prices, setPrices] = useState<Price[]>([]);
  const [, setPreviousPrices] = useState<{ [code: string]: Price }>({});
  const [highlightedRows, setHighlightedRows] = useState<{ [code: string]: "increase" | "decrease" | "no-change" }>({});
  const [piyasaActiveTab, setPiyasaActiveTab] = useState("GENEL");
  const [sarrafiyeActiveTab, setSarrafiyeActiveTab] = useState("SARRAFIYE");
  const [gramAltinActiveTab, setGramAltinActiveTab] = useState("GRAM GÜMÜS");
  const [selectedGold, setSelectedGold] = useState<GoldDetail | null>(null);
  const socketRef = useRef<WebSocket | null>(null);
  const reconnectTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const disposedRef = useRef(false);
  const attemptRef = useRef(0);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const storeImages = [
    image0,
    image0,
  
  ];

  const connectWebSocket = useCallback(() => {
    const wsUrl = "wss://sslsocket.aifanet.com/5.250.255.84/12254";

    if (reconnectTimeoutRef.current) {
      clearTimeout(reconnectTimeoutRef.current);
      reconnectTimeoutRef.current = null;
    }

    try {
      socketRef.current?.close();
    } catch {
      // ignore
    }

    socketRef.current = new WebSocket(wsUrl);

    socketRef.current.onopen = () => {
      attemptRef.current = 0;
      console.log("WebSocket bağlantısı kuruldu.");
    };

    socketRef.current.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (Array.isArray(data)) {
          const updatedPrices = data.map((item: any) => ({
            code: item.Code, // WebSocket'ten gelen orijinal kod
            bid: item.Bid,
            ask: item.Ask,
            category: item.Category === "GRAM GUMUS" ? "GRAM GUMUS" : item.Category, // MADEN kategorisini GRAM GÜMÜS olarak değiştir
            source: "WebSocket",
          }));
          

          setPrices((prevPrices) => {
            const prevPriceMap = prevPrices.reduce((acc, price) => {
              acc[price.code] = price;
              return acc;
            }, {} as { [code: string]: Price });

            const newHighlightedRows: { [code: string]: "increase" | "decrease" | "no-change" } = {};
            updatedPrices.forEach((price) => {
              const prevBid = prevPriceMap[price.code]?.bid || 0;
              const prevAsk = prevPriceMap[price.code]?.ask || 0;

              if (price.bid !== prevBid) {
                newHighlightedRows[price.code] = price.bid > prevBid ? "increase" : "decrease";
              } else if (price.ask !== prevAsk) {
                newHighlightedRows[price.code] = price.ask > prevAsk ? "increase" : "decrease";
              } else {
                newHighlightedRows[price.code] = "no-change";
              }
            });

            setHighlightedRows(newHighlightedRows);
            setPreviousPrices(prevPriceMap);
            return updatedPrices;
          });
        }
      } catch (error) {
        console.error("WebSocket mesaj hatası:", error);
      }
    };

    socketRef.current.onclose = () => {
      if (disposedRef.current) return;
      console.warn("WebSocket bağlantısı kapandı. Yeniden bağlanıyor...");
      const attempt = attemptRef.current;
      const delay = Math.min(30000, 1000 * Math.pow(2, attempt));
      attemptRef.current = attempt + 1;
      reconnectTimeoutRef.current = setTimeout(() => {
        connectWebSocket();
      }, delay);
    };

    socketRef.current.onerror = (error) => {
      console.error("WebSocket hata:", error);
      try {
        socketRef.current?.close();
      } catch {
        // ignore
      }
    };
  }, []);

  useEffect(() => {
    disposedRef.current = false;
    connectWebSocket();

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === storeImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000); // Her 3 saniyede bir resim değişecek

    return () => {
      disposedRef.current = true;
      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
        reconnectTimeoutRef.current = null;
      }
      if (socketRef.current) {
        socketRef.current.close();
      }
      clearInterval(interval);
    };
  }, [connectWebSocket, storeImages.length]);

  const piyasaPrices = prices.filter((price) => price.category === "DOVIZ");
  const sarrafiyePrices = prices.filter((price) => price.category === "SARRAFIYE");
  const madenPrices = prices.filter((price) => price.category === "MADEN");
  const gramAltinPrices = prices.filter((price) => price.category === "GRAM GUMUS");
  const usdPrices = prices.filter((price) => price.category === "USD");
  const gumusPrices = prices.filter((price) => price.category === "PARITE");
  const paritePrices = prices.filter((price) => price.category === "PARITE");
  const genelPrices = prices.filter((price) => price.category === "GENEL");

  const activePiyasaPrices =
    piyasaActiveTab === "GENEL"
      ? genelPrices
      : piyasaActiveTab === "DOVIZ"
      ? piyasaPrices
      : piyasaActiveTab === "PARITE"
      ? paritePrices
      : piyasaPrices;

  // USD/TRY kurunu bul - farklı kodlarla dene
  const usdTryRate = prices.find(price => price.code === "USD/TL")?.ask || 
                     prices.find(price => price.code === "USDTRL")?.ask ||
                     prices.find(price => price.code === "USD/TRY")?.ask ||
                     prices.find(price => price.code.includes("USD") && price.code.includes("TL"))?.ask ||
                     30; // Varsayılan değer
  
  console.log("USD/TRY kuru bulundu:", usdTryRate);
  console.log("Mevcut fiyatlar:", prices.filter(p => p.code.includes("USD")));

  const activeSarrafiyePrices =
    sarrafiyeActiveTab === "SARRAFIYE"
      ? sarrafiyePrices
      : sarrafiyeActiveTab === "MADEN"
      ? madenPrices
      : sarrafiyeActiveTab === "GRAM GUMUS"
      ? gramAltinPrices
      : sarrafiyeActiveTab === "USD"
      ? gramAltinPrices.map(price => {
          const convertedPrice = {
            ...price,
            bid: price.bid / usdTryRate,
            ask: price.ask / usdTryRate
          };
          console.log(`${price.code} dönüştürüldü: ${price.bid} TL -> ${convertedPrice.bid} USD`);
          return convertedPrice;
        })
      : sarrafiyePrices;

  const isUsdEurKgParity = (code: string): boolean =>
    /^(USD\s*\/?\s*KG|EUR\s*\/?\s*KG|USDKG|EURKG)/i.test(String(code || "").trim());

  const formatPrice = (price: number, code: string): string => {
    // Granul Gumus için özel format - tam eşleşme
    if (code === "Granul Gumus") {
      console.log("Granul Gumus formatPrice çağrıldı:", code, price);
      return price.toLocaleString("tr-TR", { minimumFractionDigits: 3, maximumFractionDigits: 3 });
    }

    // USD/KG, EUR/KG ve Çekili varyantları — tr-TR, 3 ondalık (örn. 130,808 / 131,094)
    if (isUsdEurKgParity(code) || ["USD/KG", "EUR/KG", "GÜM/TL", "GÜM/USD", "GÜM/EUR", "USD/TL", "EUR/TL"].includes(code)) {
      return price.toLocaleString("tr-TR", { minimumFractionDigits: 3, maximumFractionDigits: 3 });
    }

    // PARİTE tabında forex pariteleri (EURUSD, GBPUSD vb.) - 4 ondalık basamak
    if (piyasaActiveTab === "PARITE" && ["EURUSD", "GBPUSD", "USDCHF", "USDJPY", "USDCAD", "AUDUSD", "USDNOK", "USDSAR"].includes(code)) {
      return price.toLocaleString("tr-TR", { minimumFractionDigits: 4, maximumFractionDigits: 4 });
    }
    
    if (code === "EUR/USD") {
      return price.toLocaleString("tr-TR", { minimumFractionDigits: 4, maximumFractionDigits: 4 });
    } else if (sarrafiyeActiveTab === "SARRAFIYE" && sarrafiyePrices.some(p => p.code === code)) {
      // Sadece SARRAFIYE kategorisindeki kodlar için ondalık basamak yok
      return price.toLocaleString("tr-TR", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    } else if (sarrafiyeActiveTab === "USD" && (code.includes("GRAM") || code.includes("Kulce") || code.includes("Granul"))) {
      // USD tabında gösterilen GRAM GÜMÜS fiyatları için 2 ondalık basamak
      return price.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } else if (code.includes("USD") || usdPrices.some(p => p.code === code)) {
      // USD kategorisindeki değerler için 3 ondalık basamak
      return price.toLocaleString("tr-TR", { minimumFractionDigits: 3, maximumFractionDigits: 3 });
    } else if (paritePrices.some(p => p.code === code)) {
      // PARİTE kategorisindeki değerler için 4 ondalık basamak
      return price.toLocaleString("tr-TR", { minimumFractionDigits: 4, maximumFractionDigits: 4 });
    } else if (genelPrices.some(p => p.code === code) || piyasaPrices.some(p => p.code === code)) {
      // GENEL ve DÖVİZ kategorisindeki değerler için 3 ondalık basamak
      return price.toLocaleString("tr-TR", { minimumFractionDigits: 3, maximumFractionDigits: 3 });
    } else {
      // Diğer tüm durumlar için 3 ondalık basamak
      return price.toLocaleString("tr-TR", { minimumFractionDigits: 3, maximumFractionDigits: 3 });
    }
  };

  const handleGoldClick = (code: string) => {
    if (goldData[code]) {
      setSelectedGold(goldData[code]);
    }
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      setSelectedGold(null);
    }
  };

  if (selectedGold) {
    return (
      <div className="gold-detail-overlay" onClick={handleOverlayClick}>
        <div className="gold-detail-container">
          <button className="close-button" onClick={(e) => {
            e.stopPropagation();
            setSelectedGold(null);
          }}>
            ✕
          </button>
          <div className="gold-detail-content" onClick={(e) => e.stopPropagation()}>
            <div className="gold-image-container">
              <img src={selectedGold.image} alt={selectedGold.name} />
            </div>
            <div className="gold-info">
              <h2>{selectedGold.name}</h2>
              <div className="gold-specs">
                <div className="spec-item">
                  <span className="spec-label">Cins:</span>
                  <span className="spec-value">{selectedGold.details.Cins}</span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Ağırlık:</span>
                  <span className="spec-value">{selectedGold.details.Ağırlık}</span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Ayar:</span>
                  <span className="spec-value">{selectedGold.details.Ayar}</span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Çap:</span>
                  <span className="spec-value">{selectedGold.details.Çap}</span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Torba Adet:</span>
                  <span className="spec-value">{selectedGold.details["Torba Adet"]}</span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Kulpsuz Gram:</span>
                  <span className="spec-value">{selectedGold.details["Kulpsuz Gram"]}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="live-prices-container">
      <div className="tables-and-image">
        {/* EN SOLDA: Piyasa Fiyatları tablosu */}
        <div className="prices-table prices-table--left">
          <div className="table-header">
            <div className="tab-buttons">
              <button
                className={piyasaActiveTab === "GENEL" ? "active" : ""}
                onClick={() => setPiyasaActiveTab("GENEL")}
              >
                {t('livePrices.genel')}
              </button>
              <button
                className={piyasaActiveTab === "DOVIZ" ? "active" : ""}
                onClick={() => setPiyasaActiveTab("DOVIZ")}
              >
                {t('livePrices.doviz')}
              </button>
              <button
                className={piyasaActiveTab === "PARITE" ? "active" : ""}
                onClick={() => setPiyasaActiveTab("PARITE")}
              >
                {t('livePrices.parite')}
              </button>
            </div>
          </div>
          <div className="scrollable-table">
            <table>
              <thead>
                <tr>
                  <th>{t('livePrices.birim')}</th>
                  <th>{t('livePrices.alis')}</th>
                  <th>{t('livePrices.satis')}</th>
                </tr>
              </thead>
              <tbody>
                {activePiyasaPrices.map((price) => (
                  <tr key={price.code}>
                    <td>{price.code}</td>
                    <td
                      className={
                        highlightedRows[price.code] === "increase"
                          ? "increase"
                          : highlightedRows[price.code] === "decrease"
                          ? "decrease"
                          : "no-change"
                      }
                    >
                      {formatPrice(price.bid, price.code)}
                    </td>
                    <td
                      className={
                        highlightedRows[price.code] === "increase"
                          ? "increase"
                          : highlightedRows[price.code] === "decrease"
                          ? "decrease"
                          : "no-change"
                      }
                    >
                      {formatPrice(price.ask, price.code)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {/* ORTADA: Sarrafiye/Gram Altın/Gümüş tablosu */}
        <div className="prices-table prices-table--right">
          <div className="table-header">
            <div className="tab-buttons">
              <button
                className={sarrafiyeActiveTab === "SARRAFIYE" ? "active" : ""}
                onClick={() => setSarrafiyeActiveTab("SARRAFIYE")}
              >
                {t('livePrices.sarrafiye')}
              </button>
              <button
                className={sarrafiyeActiveTab === "MADEN" ? "active" : ""}
                onClick={() => setSarrafiyeActiveTab("MADEN")}
              >
                {t('livePrices.gramAltin')}
              </button>
              <button
                className={sarrafiyeActiveTab === "GRAM GUMUS" ? "active" : ""}
                onClick={() => setSarrafiyeActiveTab("GRAM GUMUS")}
              >
                {t('livePrices.gramGumus')}
              </button>
              <button
                className={sarrafiyeActiveTab === "USD" ? "active" : ""}
                onClick={() => setSarrafiyeActiveTab("USD")}
              >
                <USDIcon /> <span className="desktop-text">{t('livePrices.gumusUsd')}</span><span className="mobile-text">{t('livePrices.usd')}</span>
              </button>
            </div>
          </div>
          <div className="scrollable-table">
            <table>
              <thead>
                <tr>
                  <th>{t('livePrices.birim')}</th>
                  <th>{t('livePrices.alis')}</th>
                  <th>{t('livePrices.satis')}</th>
                </tr>
              </thead>
              <tbody>
                {activeSarrafiyePrices.map((price) => (
                  <tr 
                    key={price.code} 
                    onClick={(e) => {
                      e.preventDefault();
                      handleGoldClick(price.code);
                    }}
                  >
                    <td>{price.code}</td>
                    <td
                      className={
                        highlightedRows[price.code] === "increase"
                          ? "increase"
                          : highlightedRows[price.code] === "decrease"
                          ? "decrease"
                          : "no-change"
                      }
                    >
                      {price.category === "SARRAFIYE" && sarrafiyeValues[price.code] && (
                        <SmallBox label={price.code} type="bid" />
                      )}
                      {price.category === "GRAM GÜMÜS" && (
                        <SmallBox label={price.code} type="bid" />
                      )}
                      {formatPrice(price.bid, price.code)} {sarrafiyeActiveTab === "USD" ? "$" : (price.category === "SARRAFIYE" && "₺")}
                    </td>
                    <td
                      className={
                        highlightedRows[price.code] === "increase"
                          ? "increase"
                          : highlightedRows[price.code] === "decrease"
                          ? "decrease"
                          : "no-change"
                      }
                    >
                      {price.category === "SARRAFIYE" && sarrafiyeValues[price.code] && (
                        <SmallBox label={price.code} type="ask" />
                      )}
                      {price.category === "GRAM GÜMÜS" && (
                        <SmallBox label={price.code} type="ask" />
                      )}
                      {formatPrice(price.ask, price.code)} {sarrafiyeActiveTab === "USD" ? "$" : (price.category === "SARRAFIYE" && "₺")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {/* EN SAĞDA: Görsel ve döviz çevirici */}
        <div className="store-image store-image--panel">
          <img
            src={storeImages[currentImageIndex]}
            alt={`Store ${currentImageIndex + 1}`}
            className="slide-image"
          />
          <div className="slide-divider"></div>
          <div className="mobile-app-links">
            <a href="https://apps.apple.com/tr/app/has-g%C3%BCm%C3%BC%C5%9F/id1545326507?l=tr" target="_blank" rel="noopener noreferrer">
              <img src={iosImg} alt="App Store" className="mobile-app-img" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.aifasoft.has_gumus&hl=tr" target="_blank" rel="noopener noreferrer">
              <img src={googleImg} alt="Google Play" className="mobile-app-img" />
            </a>
          </div>
        </div>

        <div className="convert-panel">
          <div className="center-convert-calculator-container">
            <BottomConvertCalculator prices={prices} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LivePrices;
